import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

/** Public runtime configuration (feature flags, limits, AI region, push key). Cached for an hour. */
export function usePublicConfig() {
  return useQuery({
    queryKey: queryKeys.config,
    queryFn: () => api.config(),
    staleTime: 60 * 60_000,
    retry: false,
  });
}
